import { useState } from "react";
import { IoMdArrowDropright, IoMdArrowDropdown } from "react-icons/io";
import ProductDisplayProduct from "./ProductDisplayProduct";
import { FaUserTie } from "react-icons/fa";
   
import { MdBadge } from "react-icons/md";
import { FaCalendarCheck, FaCalendarMinus, FaRegClock } from "react-icons/fa";
import request from "graphql-request";
import BASEURL from "../../../../pages/Utils/Baseurl";
import { agreedProductsByMallId } from "./data";

const ProductDisplayMall = ({
  marketName,
  id,
  address,
  contactPerson,
  contactNumber,
  contractStart,
  contractEnd,
  completeWithin,
  status,
  agreedProducts = [],
  agreenProductOpen,
  setAgreenProductOpen,
  remarksOpen,
  setRemarksOpen,
  setDatas,
  datas,
  handleDeleteMall,
  tabValue,
  handleRecoildialog,
  agentCode,
  agentName,
}) => {
  const [productOpenStatus, setProductOpenStatus] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [productData, setProductData] = useState([]);

  const fetchMallProductData = async (id) => {
    setIsLoading(true);
    try {
      const response = await request(BASEURL, agreedProductsByMallId, {
        mallId: id,
      });

      const success = response?.agreedProductsByMallId?.success;

      if (success) {
        setProductData(response?.agreedProductsByMallId?.data);
      } else {
        setProductData([]);
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  const handleFetchclick = (id) => {
    setProductOpenStatus((prev) => {
      const newStatus = !prev;
      if (newStatus) {
        fetchMallProductData(id);
      }
      return newStatus;
    });
  };

  return (
    <div className="productdisplaybox">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div
          onClick={() => handleFetchclick(id)}
          style={{
            display: "flex",
            // justifyContent: "space-between",
            alignItems: "center",
            width: "25%",
            cursor: "pointer",
          }}
        >
          {productOpenStatus ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}

          <h2 className="marketname">{marketName}</h2>
        </div>

        <div className="productmallcontactbox" title="Agent Code">
          <MdBadge className="productmall-icon" />
          <p>{agentCode}</p>
        </div>
        <div className="productmallcontactbox" title="Agent Name">
          <FaUserTie className="productmall-icon" />
          <p>{agentName}</p>
        </div>

        <div className="productmallcontractbox" title="contract Start">
          <FaCalendarCheck className="productmall-icon" />
          <p>{contractStart}</p>
        </div>
        <div className="productmallcontractbox" title="contract End">
          <FaCalendarMinus className="productmall-icon" />
          <p>{contractEnd}</p>
        </div>
        <div className="productmallcontractbox" title="complete With In">
          <FaRegClock className="productmall-icon" />
          <p>{completeWithin}</p>
        </div>
      </div>
      {productOpenStatus && (
        <div>
          <ProductDisplayProduct
            agreedProducts={productData}
            contractStart={contractStart}
            contractEnd={contractEnd}
            completeWithin={completeWithin}
            address={address}
            isLoading={isLoading}
            agreenProductOpen={agreenProductOpen}
            setAgreenProductOpen={setAgreenProductOpen}
            remarksOpen={remarksOpen}
            setRemarksOpen={setRemarksOpen}
            setDatas={setDatas}
            datas={datas}
            handleDeleteMall={handleDeleteMall}
            mallId={id}
            tabValue={tabValue}
            handleRecoildialog={handleRecoildialog}
            contactNumber={contactNumber}
            contactPerson={contactPerson}
          />
        </div>
      )}
    </div>
  );
};

export default ProductDisplayMall;
